export enum InputType {
  Checkbox = 'checkbox',
  File = 'file',
  MultiSelect = 'multi_select',
  Other = 'other',
  Radio = 'radio',
  SingleSelect = 'select',
  // Distinct from SingleSelect ('select'): this is the API's `single_selection`, currently used
  // only by the server-owned select-sub-select discriminator input.
  SingleSelection = 'single_selection',
  Text = 'text',
  TextArea = 'textarea',
}

export enum InputDataType {
  Date = 'date',
  EIN = 'ein',
  Email = 'email',
  FullDate = 'fulldate',
  HHIncome = 'hhincome',
  HHSize = 'hhsize',
  IdNumber = 'idnumber',
  Number = 'number',
  Password = 'password',
  Phone = 'phone',
  ShortDate = 'shortdate',
  SSN4 = 'ssn4',
  SSN9 = 'ssn9',
  Url = 'url',
  ZipCode = 'zipcode'
}

export enum HeaderOption {
  Header,
  Instructions
}

export enum Validation {
  DuplicateValue = 'duplicateValue',
  InvalidEmail = 'invalidEmail',
  InvalidFEIN = 'invalidFEIN',
  InvalidHHSize = 'invalidHHSize',
  InvalidName = 'invalidName',
  InvalidNumberOrDecimal = 'invalidNumberOrDecimal',
  InvalidPhone = 'invalidPhone',
  InvalidNumber = 'invalidNumber',
  InvalidSSN = 'invalidSSN',
  InvalidUrl = 'invalidUrl',
  InvalidZipCode = 'invalidZipCode',
  Maximum = 'max',
  MaxLength = 'maxlength',
  Minimum = 'min',
  Pattern = 'pattern',
  Required = 'required'
}

export enum Placeholder {
  County = 'Select County',
  GradeLevel = 'Select Grade Level',
  School = 'Select School',
  SchoolDistrict = 'Select School District',
  Select = '-Please Select',
  State = 'Select State',
  // Distinct from School (the K12 institution directory): backs the Provider wizard's NSC
  // degree-institution autocomplete, sourced from Provider.EmployeeSchool via GET partners/schools.
  ProviderDegreeSchool = 'Select Degree School'
}

/**
 * Placeholders whose input options are reference data the renderer rebuilds on every load
 * (PcFormFieldComponent.setDropdownOptions) instead of prompt data the API owns. Keep this list in
 * step with that switch. The admin builder must not send these back: they are not the prompt's own
 * data, and the county and grade lists are label-only, which the API's option contract rejects
 * because `value` is required there.
 */
export const REFERENCE_DROPDOWN_PLACEHOLDERS: readonly string[] = [
  Placeholder.County,
  Placeholder.GradeLevel,
  Placeholder.ProviderDegreeSchool,
  Placeholder.School,
  Placeholder.SchoolDistrict,
  Placeholder.State
];

export const isReferenceDropdownPlaceholder = (placeholder: string | null | undefined): boolean =>
  placeholder != null && REFERENCE_DROPDOWN_PLACEHOLDERS.includes(placeholder);

export enum InputLabel {
  Label1 = 'Label 1',
  SSN = 'Last 4 SSN'
}

export enum DropdownType {
  County = 'County',
  GradeLevel = 'Grade Level',
  SchoolDistrict = 'School District',
  State = 'state'
}
